import { render, staticRenderFns } from "./LoginSupport.vue?vue&type=template&id=ef64ce08&scoped=true&"
import script from "./LoginSupport.vue?vue&type=script&lang=ts&"
export * from "./LoginSupport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef64ce08",
  null
  
)

export default component.exports